<template>
	<div>
		<p class="pb-3">
			{{label}}
		</p>
		<div class="centerx w-1/5 m-auto">
			<vs-input-number class="w-full" v-model="answerSend" :disabled="disabled" color="success" :min="min" :max="max"/>
		</div>
	</div>
</template>

<script type="text/javascript">
	import { mapState, mapMutations } from 'vuex';
	export default {
		props: {
			label: {
				type: String,
				required: false,
				default: 'Descripción'
			},
			answer: {
				type:  Number,
				required: false,
				default: 0
			},
			disabled: {
				type: Boolean,
				required: false,
				default: false
			},
			mini: {
				type: Number,
				required: false,
				default: 0
			},
			maxi: {
				type: Number,
				required: false,
				default: 1
			}
		},
		data() {
			return {
				value: ''
			}
		},
		computed: {
			...mapState('resource', ['indexQuestion', 'questionsByPage']),
            /**
             * Obtiene el valor mínimo de las props
             */
			min() {
				return this.mini
			},
            /**
             * Obtiene el valor máximo de las props
             */
			max() {
				return this.maxi
			},
			answerSend: {
				get() {
					return this.answer;
				},
				set(value) {
					this.$emit('input', parseInt(value))
				}
			}
		}

	}

</script>
